import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../services/user.service';

@Component({
  standalone: true,
  selector: 'dev-nav',
  imports: [CommonModule, RouterLink, ButtonModule],
  templateUrl: './dev-nav.component.html',
  styleUrl: './dev-nav.component.scss',
})
export class DevNavComponent {

  user = inject(UserService);
  router = inject(Router);

  logOut() {
    this.user.removeUserData();
    this.router.navigate(['/']);
  }
}
